import React, { useState, useCallback, useMemo } from "react";
import { Parameters } from "../MachineTaskConstants";
import FormSkel from "../../../../../components/Modals/FormSkel";

const ParameterGetForm = ({ isOpen, onClose, onSubmit, generateTaskId }) => {
  const [selectedParamIndex, setSelectedParamIndex] = useState(0);
  const [startAt, setStartAt] = useState("");

  const currentParam = useMemo(() => Parameters[selectedParamIndex], [selectedParamIndex]);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    
    const parameterAddress = currentParam.address;
    const task = {
      id: generateTaskId(),
      taskType: "GET_PARAMETER",
      parameterAddress,
      startAt: startAt || null,
      datetimeType: startAt ? "single" : null,
    };
    
    onSubmit(task);
    setStartAt("");
    setSelectedParamIndex(0);
  }, [currentParam, startAt, onSubmit, generateTaskId]);

  const handleClose = useCallback(() => {
    setStartAt("");
    setSelectedParamIndex(0);
    onClose();
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <FormSkel
      headerText="Odczytaj parametr z płyty VMC"
      handleClose={handleClose}
      acceptForm="true"
    >
      <div>
        <form onSubmit={handleSubmit} id="modal-form">
          <div className="form-group">
            <label htmlFor="parameter-select" className="form-label font-weight-bold">
              Wybierz parametr do pobrania
            </label>
            <select 
              className="form-control" 
              id="parameter-select"
              name="value"
              value={selectedParamIndex}
              onChange={(e) => setSelectedParamIndex(Number(e.target.value))}
              required
            >
              {Parameters.map((parameter, index) => (
                <option key={index} value={index}>
                  [Adres {parameter.address}] {parameter.desc}
                </option>
              ))}
            </select>
            <small className="form-text text-muted">
              Opis: {currentParam.desc} (Zakres: {currentParam.min} - {currentParam.max})
            </small>
          </div>
          
          <div className="form-group mb-0">
            <label htmlFor="datetimeGet" className="form-label font-weight-bold">
              Kiedy wykonać (opcjonalnie)
            </label>
            <input
              type="datetime-local"
              className="form-control"
              id="datetimeGet"
              value={startAt}
              onChange={(e) => setStartAt(e.target.value)}
            />
            <small className="form-text text-muted">
              Pozostaw puste dla natychmiastowego wykonania.
            </small>
          </div>
        </form>
      </div>
    </FormSkel>
  );
};

export default ParameterGetForm;
